import { render } from "./PasswordReset.vue?vue&type=template&id=9567fec4"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
script.render = render

export default script